import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import cricketWomanImage from "./assets/cricketWomanImage.png"

export const games = [
  {
    image: "https://badmintonhq.co.uk/cdn/shop/articles/123.jpg?v=1704207657",
  title: "Badminton",
  description: 'Professional badminton training with qualified coaches and world-class facilities, designed to enhance skills, speed, match pressure and on-court performance.',
  link: "/game/badminton"
  },
  {
    image: "https://askmesportsalliance.com/static/media/meditationImage.261162b4a51e790c9a70.jpeg",
    title: "Sports Meditation",
    description: "Sports meditation is not just about sitting still — it’s a powerful practice that helps athletes master their minds and control breath to reach peak performance.",
    link: "/game/sportsMeditation"
  },
  {
    image: "https://www.thehawk.in/_next/image?url=https%3A%2F%2Fd2py10ayqu2jji.cloudfront.net%2FSports%2520Psychologist.webp&w=3840&q=75",
    title: "Sports Psychologist",
    description: "Sports psychologist helps to develop the champion mindset of athletes to build mental strength, boost confidence, manage stress, and stay focused to perform at their absolute best.",
    link: "/game/sportsPsychologits"
  },
  {
    image: "https://img.freepik.com/free-photo/tanned-young-athletic-girl-doing-abs-workout-yoga-mat_651396-1725.jpg?semt=ais_incoming&w=740&q=80",
    title: "Sports Fitness",
    description: "Sports fitness enhances strength, stamina, speed, suppleness, agility, and injury free for overall conditioning to help athletes perform efficiently and stay at the top of their game.",
    link: "/game/sportsFitness"
  },
  {
    image: cricketWomanImage,
    title: "Cricket (Women)",
    description: "A Women’s cricket is not in vogue in India, a beginner to a champion in cricket is a process that requires dedication, skill development, and a clear understanding of the pathway to professional play. Our programs with expert coaching, focused on skill-building, fitness, and on-field performance.",
    link: "/game/cricket-women"
  },
  {
    image: "https://images.indianexpress.com/2021/05/indian-shooting.jpg?w=414",
    title: "Shooting",
    description: "Professional shooting training and precision coaching with systematic approach, designed to improve accuracy, focus, and competitive performance.",
    link: "/game/shooting"
  },
  {
    image: "https://thumbs.dreamstime.com/b/back-view-shot-indian-senior-man-busy-playing-tennis-hitting-ball-racquet-court-concept-mistakes-practising-280198852.jpg",
    title: "Tennis",
    description: "Embarking on the journey from a tennis beginner to a champion is a multi-faceted endeavor that requires dedication, strategic training, and a deep understanding of the game. Professional tennis training and development advance programs with experienced coaches.",
    link: "/game/tennis"
  },
  {
      image: "https://media.istockphoto.com/id/1417521713/photo/man-serving-ping-pong-ball.jpg?s=612x612&w=0&k=20&c=vGma8XB9cxDV29ndMM8ww5QVhJDJCCaGMnpzdMiABDM=",
    title: "Table Tennis",
    description: "Growing from a table tennis beginner to a skilled competitor takes commitment, focused training, and a clear understanding of the sport. Expert-led development programs refine technique and elevate players to their highest potential.",
    link: "/game/table-tennis"
  },
  {
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJNlkcNdBQATdXu48RoKMbZjjls6X3CvGGfA&s",
    title: "Weightlifting",
    description: "Progressing from a weightlifting beginner to a strong, disciplined athlete requires consistency, precise technique, and an understanding of body mechanics. Expert-guided training programs build power, refine form, and unlock your true strength. ",
    link: "/game/weightlifting"
  },
  {
    image: "https://asianvolleyball.net/new/wp-content/uploads/2019/11/men-india-v-nepal3.jpg",
    title: "Volleyball",
    description: "Growing from a volleyball beginner to a confident, high-level player takes dedication, smart teamwork, and a deep understanding of the sport. Professional coaching and development programs sharpen skills, boost agility, and elevate overall performance.",
    link: "/game/volleyball"
  },
  {
    image: "https://d16f573ilcot6q.cloudfront.net/wp-content/uploads/2024/09/WhatsApp-Image-2024-09-05-at-3.18.09-PM.jpeg",
    title: "Powerlifting",
    description: "Advancing from a powerlifting beginner to a disciplined, high-strength athlete demands consistency, technical mastery, and a deep understanding of lifting mechanics. Expert-driven training programs refine form, build explosive power, and push you toward peak performance.",
    link: "/game/powerlifting"
  },
  {
    image: "https://images.unsplash.com/photo-1564097147829-44f8c74a8549?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8Ym94aW5nJTIwaW5kaWFucyd8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&q=60&w=400",
    title: "Boxing",
    description: "Rising from a boxing beginner to a skilled, disciplined fighter takes relentless practice, sharp technique, and a strong grasp of ring fundamentals. Expert-led training programs refine movement, build power, and develop the mindset needed for peak performance.",
    link: "/game/boxing"
  },
  {
    image: "https://t4.ftcdn.net/jpg/02/91/47/51/360_F_291475113_YiOkYHzE185Lk1897MNmDaRzrf9hSSfr.jpg",
    title: "Athletics",
    description: "Evolving from an athletics beginner to a high-performing athlete requires discipline, structured training, and a deep understanding of movement. Professional development programs enhance speed, endurance, and technique to push you toward peak performance.",
    link: "/game/athletics"
  },
];

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
